import { render, staticRenderFns } from "./addPartner.vue?vue&type=template&id=54aecd1e&scoped=true&"
import script from "./addPartner.vue?vue&type=script&lang=js&"
export * from "./addPartner.vue?vue&type=script&lang=js&"
import style0 from "./addPartner.vue?vue&type=style&index=0&id=54aecd1e&prod&lang=scss&"
import style1 from "./addPartner.vue?vue&type=style&index=1&id=54aecd1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aecd1e",
  null
  
)

export default component.exports